import React, { Component } from 'react';
import { connect } from 'react-redux';

import { history } from '../../helpers';
import { templateMngService } from '../../services';
import { alertActions } from '../../modules/alert';

import Popup from '../Dialog/Popup'
import Confirm from '../Dialog/Confirm';
import ThemeInputComp from './ThemeInputComp';

class TemplateMod extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            themes:[],
            valueChange: false,
            submitted: false,
            message: '',
            open: false,
            confirm: false,
            confirmKind: '',
            codes : props.codes,
        }

        this.getTemplateInfo(this.props.location.state.templateID);
    }

    getTemplateInfo = (templateID) => {
        templateMngService.getByID(templateID)
            .then((response) => {
                console.log(response.data);
                this.setState({
                    ...this.state,
                    name: response.data.name,
                    themes: response.data.themes,
                });
            })
            .catch(this.handleErrors);
    };

    handleValueChange = (e) => {
        // name 100자 체크
        if (e.target.name === "name" && e.target.value.length > 100) {
            this.props.errorAlerts("경고 100자 초과");
        }
        else {
            this.setState({
                valueChange: true,
                [e.target.name]: e.target.value
            });
        }
    };

    

    enterPressed = (e) => {
        let code = e.keyCode || e.which;
        if (code === 13) { //13 is the enter keycode
            this.buttonAdd.click();
        }
    };

    handleFormSubmit = (e) => {
        e.preventDefault();

        if (this.state.kind === "save") {
            this.setState({
                submitted: true
            });

            if (this.validation()) {
                this.modTemplate();
            }
        }
        if (this.state.kind === "del") {
            this.delTemplate(this.props.location.state.templateID);
        }
    };

    validation = () => {
        const layoutThemeCodes = this.state.codes.filter((c) => { return c.parentCode === 'TM001' && c.code !== 'TM001'; });
        let keypadThemeCodes = [];
        this.state.themes.map((theme) => {
            if (!keypadThemeCodes.includes(theme.keypadThemeCode)) keypadThemeCodes.push(theme.keypadThemeCode);
            return theme;
        });

        if (!this.state.name) {
            this.props.errorAlerts("템플릿제목은 필수 입력 값입니다.");
            return false;
        } else if (layoutThemeCodes.length !== this.state.themes.filter(theme => theme.keypadThemeCode === "TM002001").length) {
            this.props.errorAlerts("텐키방식은 필수 입력 값입니다.");
            return false;
        } else if ((keypadThemeCodes.includes("TM002002") && layoutThemeCodes.length !== this.state.themes.filter(theme => theme.keypadThemeCode === "TM002002").length) ||
                   (keypadThemeCodes.includes("TM002003") && layoutThemeCodes.length !== this.state.themes.filter(theme => theme.keypadThemeCode === "TM002003").length) ||
                   (keypadThemeCodes.includes("TM002004") && layoutThemeCodes.length !== this.state.themes.filter(theme => theme.keypadThemeCode === "TM002004").length)) {
            this.props.errorAlerts("비어있는 층입력방식이 있습니다.");
            return false;
        }
        else {
            return true;
        }
    };

    appendTheme = (theme) => {
        const { themes } = this.state;
        let targetIndex = -1;
        for(let i = 0; i < themes.length; i++) {
            if(themes[i].layoutThemeCode === theme.layoutThemeCode
                && themes[i].keypadThemeCode === theme.keypadThemeCode
                && themes[i].sort === theme.sort)
                targetIndex = i;
        }

        let targetThemes = [...themes];
        if(targetIndex > -1){
            targetThemes[targetIndex] = theme;
        }else{
            targetThemes.push(theme);
        }
        this.setState({
            themes: targetThemes,
            valueChange: true
        });
    };

    modTemplate = () => {
        let formData = new FormData();
        formData.append('templateID', this.props.location.state.templateID);
        formData.append('name', this.state.name);

        templateMngService.mod(formData)
            .then((response) => {
                if (response.status === 200) {
                    //history.goBack();
                    //테마 저장
                    for(let i = 0; i < this.state.themes.length; i++){
                        let theme = this.state.themes[i];
                        if(theme.themeID > -1) {
                            if(theme.valueChange)
                                this.modTheme(theme);
                        } else {
                            theme.templateID = this.props.location.state.templateID;
                            this.addTheme(theme);
                        }
                    }

                    this.setState({
                        confirm: true,
                        confirmKind: 'mod'
                    });
                }
            })
            .catch(this.handleErrors);
    };

    delTemplate = (templateID) => {
        templateMngService.del(templateID)
            .then((response) => {
                if (response.data.result === 1) {
                    this.setState({
                        confirmKind: "del",
                        confirm: true
                    })
                }
                else {
                    this.props.errorAlerts('삭제를 실패하였습니다.');
                }
            })
            .catch(this.handleErrors);
    };

    addTheme = (theme) => {
        let formData = new FormData();
        formData.append('templateID', theme.templateID);
        formData.append('layoutThemeCode', theme.layoutThemeCode);
        formData.append('keypadThemeCode', theme.keypadThemeCode);
        formData.append('sort', theme.sort);
        formData.append('defaultYN', theme.defaultYN);
        formData.append('themeFiles', theme.themeFiles);
        templateMngService.addTheme(formData)
            .then((response) => {
                if (response.status === 200) {
                }
            })
            .catch(this.handleErrors);
    };

    modTheme = (theme) => {
        let formData = new FormData();
        formData.append('themeID', theme.themeID);
        formData.append('templateID', theme.templateID);
        formData.append('layoutThemeCode', theme.layoutThemeCode);
        formData.append('keypadThemeCode', theme.keypadThemeCode);
        formData.append('sort', theme.sort);
        formData.append('defaultYN', theme.defaultYN);
        formData.append('themeFiles', theme.themeFiles);
        templateMngService.modTheme(formData)
            .then((response) => {
                if (response.status === 200) {
                }
            })
            .catch(this.handleErrors);
    };

    handleModButton = () => {
        this.setState({
            message: "수정 하시겠습니까?",
            kind: "save",
            open: true
        });
    };

    handleDelButton = () => {
        this.setState({
            message: "템플릿을 삭제하시겠습니까?",
            kind: "del",
            open: true
        });
    };

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    handleClose = () => {
        if (this.state.valueChange) {
            this.setState({
                message: "취소하시겠습니까?\n입력된 정보는 삭제됩니다.",
                kind: "fail",
                open: true
            });
        }
        else {
            history.goBack();
        }
    };

    handleGoBack = () => {
        history.goBack();
    };

    handleConfirmClose = () => {
        this.setState({
            open: false
        })
    };


    render() {
        const { name, codes, themes } = this.state;

        const layoutThemeCodes = codes.filter((c) => { return c.parentCode === 'TM001' && c.code !== 'TM001'; });
        
        const addThemeInputComp = (parentCode, layoutThemeCode, layoutThemeIndex, codes, themes) => {
            codes = codes.filter((c) => {
                return c.parentCode === parentCode && c.code !== parentCode;
            });
            return codes.map((c, index) => {
                let myTheme;
                for(let i = 0; i < themes.length; i++) {
                    if(themes[i].layoutThemeCode === layoutThemeCode && themes[i].keypadThemeCode === c.code){
                        myTheme = themes[i];
                        break;
                    }
                }

                return <ThemeInputComp key={c.code} myTheme={myTheme} codeItem={c} layoutThemeCode={layoutThemeCode} default={index===0 ? true : false} sort={layoutThemeIndex*4 + index} appendTheme={this.appendTheme}/>
            });
        }
        return (
            <>
                {/* 01템플릿수정 */}
                <h2 className="s-page-tit">
                    템플릿 수정
                </h2>

                <div className="search-result-wrapper contents-add s-normal-box">
                    {/* 템플릿제목 */}
                    <div className="s-form-cont">
                        <div className="row">
                            <div className="contents-mod-title col-lg-2 col-md-2 col-sm-4 col-4">템플릿제목 <span className="text-color-red">*</span><br/><span className="contents-mod-title-length">({name.length}/100)</span></div>
                            <div className="text-align-left col-lg-10 col-md-10 col-sm-8 col-8">
                                <input className="w100per padding-l10" name="name" value={name} onChange={this.handleValueChange} onKeyPress={this.enterPressed} />
                            </div>
                        </div>
                    </div>
                </div>


                {layoutThemeCodes &&
                    layoutThemeCodes.map((c, index) => {
                        return <div key={index} className="search-result-wrapper contents-add s-normal-box s-mt-30">
                            <div className="row">
                                <div className="col-lg-2 s-form-tit">
                                    <strong>{c.name}</strong>
                                    <span className="s-small-text">(스크린샷 첨부)</span>
                                </div>
                                <div className="col-lg-10 s-pr-0 s-form-cont">
                                    {addThemeInputComp('TM002', c.code, index, codes, themes)}
                                </div>
                            </div>
                        </div>;
                    })
                }
                
                <div className="search-button-wrapper text-align-right">
                    <button className={`button w100-button margin-r10 ${!this.state.valueChange && "disabled-button"}`} onClick={this.handleModButton} ref={button => this.buttonAdd = button} disabled={!this.state.valueChange}>수정</button>
                    <button className="button w100-button margin-r10" name="삭제" onClick={this.handleDelButton}>삭제</button>
                    <button className="button w100-button white-button" onClick={this.handleClose}>목록</button>
                </div>
                
                {this.state.open === true &&
                    <Confirm message={this.state.message} kind={this.state.kind} handleFormSubmit={this.state.kind === "fail" ? this.handleGoBack : this.handleFormSubmit} handleClose={this.handleConfirmClose} />
                }
                {this.state.confirm === true &&
                    <Popup message={this.state.confirmKind === "mod" ? "수정했습니다." : "삭제했습니다."} stateRefresh={this.handleGoBack} />
                }
            </>
        )
    }
}

function mapState(state) {
    const { codemng } = state;
    const { codes } = codemng;
    return {codes};
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(TemplateMod);